import React, { ReactNode } from "react";

import { Link } from "react-router-dom";

import { Button } from "@mapmycustomers/ui";

import { ClassName } from "@app/types/ui/ClassName";

interface BaseProps extends ClassName {
  children: ReactNode;
}

interface Props extends BaseProps {
  path: string;
}

const ModernLink: React.FC<Props> = ({ children, className, path }) => (
  <Link to={path}>
    <Button className={className} type="link">
      {children}
    </Button>
  </Link>
);

export default ModernLink;
